var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 27,
    viewBox: "0 0 25 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8507 18.1425C19.1194 17.271 17.82 17.1573 16.9485 17.8887C16.077 18.62 15.9634 19.9194 16.6947 20.7909L19.8507 18.1425ZM21.0584 25.9909C21.7897 26.8624 23.0891 26.976 23.9606 26.2447C24.8321 25.5133 24.9457 24.214 24.2144 23.3425L21.0584 25.9909ZM18.3945 11.6667C18.3945 15.3019 15.4231 18.2733 11.7273 18.2733V22.3933C17.6714 22.3933 22.5145 17.6044 22.5145 11.6667H18.3945ZM11.7273 18.2733C8.03148 18.2733 5.06 15.3019 5.06 11.6667H0.94C0.94 17.6044 5.78318 22.3933 11.7273 22.3933V18.2733ZM5.06 11.6667C5.06 8.03142 8.03148 5.06 11.7273 5.06V0.94C5.78318 0.94 0.94 5.72898 0.94 11.6667H5.06ZM11.7273 5.06C15.4231 5.06 18.3945 8.03142 18.3945 11.6667H22.5145C22.5145 5.72898 17.6714 0.94 11.7273 0.94V5.06ZM16.6947 20.7909L21.0584 25.9909L24.2144 23.3425L19.8507 18.1425L16.6947 20.7909Z",
    fill: "#1FBDB7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.3e5083fa69fc197c31326f41348f06b6.svg";
export { ForwardRef as ReactComponent };